import { colors } from './colors';
import { metalsList } from './metals';
import { apnumber } from 'journalize';

export function renderTooltip(p, reportsData) {
  let bsk_id = p.bsk_id.toLowerCase();
  let doc_url = reportsData[bsk_id];

  let label = p.Label.replace('A house', '');

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const tableBody = document.createElement('tbody');

  metalsList.forEach((item, i) => {
    let tRow = document.createElement('tr');
    let tHead = document.createElement('th');
    tHead.className = 'text-left';
    tHead.scope = 'row';
    tHead.innerHTML = capitalize(item);

    let tData = document.createElement('td');
    let barContainer = document.createElement('bar-container');
    barContainer.className = 'bar-container';

    let resultsBar = document.createElement('div');

    resultsBar.className = 'results-bar';
    resultsBar.style['background-color'] = colors[item][2];
    resultsBar.style['width'] = (p[item] * 100) / 5 + '%';

    barContainer.append(resultsBar);

    let resultsValue = document.createElement('div');

    if (p[item] == '0') {
      resultsValue.innerHTML = 'Not detected';
    } else {
      resultsValue.innerHTML = p[item];
    }

    resultsValue.classList.add('text-right', 'results-value');

    barContainer.append(resultsValue);

    let goalBar = document.createElement('div');
    goalBar.className = 'bar';

    barContainer.append(goalBar);

    tData.append(barContainer);
    tRow.append(tHead, tData);

    tableBody.append(tRow);
  });

  let status =
    p.type == ' Standing' ? p.type.toLowerCase().trim() : 'Destroyed';

  let asX = p.arsenic > 1;
  let pbX = p.lead > 1;
  let hgX = p.mercury > 1;
  let exceedanceTotal = asX + pbX + hgX;

  let t = `<div class="tooltip" aria-live="polite">
      <h3 class="tooltip-title">${capitalize(status)} home ${label} home</h3>
      <p> Test results 
        ${
          exceedanceTotal > 0
            ? `exceeded the health-based standard for at least ${apnumber(
                exceedanceTotal
              )} metals.`
            : 'did not exceed health-based standards for arsenic, lead or mercury.'
        }
      </p>
      <table class="tooltip-table">
        <thead>
          <tr>
            <th scope="col" class="text-left">Metal</th>
            <th scope="col" class="text-right">Times above standard</th>
          </tr>
        </thead>
        ${tableBody.innerHTML}

        </table>
        <p class="view-more"><a href=${doc_url} target="_blank" rel="nofollow">View more test results for this property</a></p>
    </div>`;
  return t;
}
